'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = FramedComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function FramedComponent(InnerComponent) {
  var IframeContainer = function (_Component) {
    _inherits(IframeContainer, _Component);

    function IframeContainer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, IframeContainer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IframeContainer.__proto__ || Object.getPrototypeOf(IframeContainer)).call.apply(_ref, [this].concat(args))), _this), _this.updateIFrameContents = function () {
        var others = _objectWithoutProperties(_this.props, []);

        _reactDom2.default.render(_react2.default.createElement(InnerComponent, others), _this.el);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(IframeContainer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var frameBody = this._iframe.contentDocument.body;
        var el = document.createElement('div');
        frameBody.appendChild(el);
        this.el = el;
        this.updateIFrameContents();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.updateIFrameContents();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement('iframe', _extends({
          ref: function ref(node) {
            return _this2._iframe = node;
          }
        }, this.props.frameProps));
      }
    }]);

    return IframeContainer;
  }(_react.Component);

  IframeContainer.defaultProps = {
    frameProps: {
      frameBorder: 0
    }
  };

  return IframeContainer;
}